import {
  Compass,
  KeyRound,
  Landmark,
  MoveDownRight,
  Boxes,
  CalendarDays,
  Settings,
  FileInput,
  SquareArrowOutUpRight,
  Ruler,
  Users,
  Layers3,
  NotebookText,
  Download
} from "lucide-react";

export const GetPropsHeader = (path) => {
  var pathName = "";
  var pathIcon = "";
  switch (path) {
    case "/app/client/managerial":
      pathName = "Painel Gerencial";
      pathIcon = (
        <Compass
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/client/kpi/cash-flow-v2":
      pathName = "KPI";
      pathIcon = (
        <KeyRound
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/client/revenues":
      pathName = "Receita";
      pathIcon = (
        <Landmark
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/client/expenses":
      pathName = "Despesas";
      pathIcon = (
        <MoveDownRight
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/client/cash-flow":
      pathName = "Fluxo de Caixa Diário";
      pathIcon = (
        <Boxes
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/client/cash-flow-month":
      pathName = "Fluxo de Caixa Mensal";
      pathIcon = (
        <CalendarDays
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/client/income-statement-v2":
      pathName = "DRE Gerencial";
      pathIcon = (
        <Settings
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/client/bills-pay":
      pathName = "Contas à Pagar";
      pathIcon = (
        <FileInput
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/client/bills-receive":
      pathName = "Contas à Receber";
      pathIcon = (
        <SquareArrowOutUpRight
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/client/cost-center":
      pathName = "Centro de Custo";
      pathIcon = (
        <Ruler
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/admin/client":
      pathName = "Clientes";
      pathIcon = (
        <Users
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/admin/user":
      pathName = "Usuários";
      pathIcon = (
        <Users
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
    case "/app/admin/category":
      pathName = "Categorias";
      pathIcon = (
        <Layers3
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
      case "/app/admin/mapping-cash-flow":
      pathName = "Plano de contas FC";
      pathIcon = (
        <NotebookText
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
      case "/app/admin/mapping-income":
      pathName = "Plano de contas DRE";
      pathIcon = (
        <NotebookText
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;
      case "/app/admin/import":
        pathName = "Importação de dados";
        pathIcon = (
          <Download
            color="#9FA1AA"
            size={15}
            style={{ marginBottom: "-2px", marginRight: "5px" }}
          />
        );
        break;
        case "/app/admin/cash-flow":
          pathName = "Fluxo de Caixa Mensal";
          pathIcon = (
            <CalendarDays
              color="#9FA1AA"
              size={15}
              style={{ marginBottom: "-2px", marginRight: "5px" }}
            />
          );
          break;
          case "/app/admin/income":
            pathName = "DRE Gerencial";
            pathIcon = (
              <Settings
                color="#9FA1AA"
                size={15}
                style={{ marginBottom: "-2px", marginRight: "5px" }}
              />
            );
            break;
    default:
      break;
  }
  return { pathName, pathIcon };
};
